import styled, { css } from "styled-components";

import TableContainer from "@material-ui/core/TableContainer";

const primary = (props) => props.theme.palette.primary;
const blue = (props) => props.theme.palette.blue;

export const CustomContainer = styled(TableContainer)`
  &.smallFont {
    table tbody tr td {
      font-size: 0.675rem !important;
    }
  }

  table thead tr th.MuiTableCell-stickyHeader {
    top: -1px;
    background-color: #f5f5f5;
  }
`;

export const CustomTable = styled.div`
  max-width: 100%;
  ${(props) =>
    props.fullWidth &&
    css`
      width: 100%;
    `}
  ${CustomContainer} {
    &::-webkit-scrollbar {
      width: 10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 5px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${primary};
      border-radius: 5px;
      border: 1px solid #f1f1f1;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${blue};
    }
  }

  &.GerenciamentoContrato {
    ${CustomContainer} {
      table tbody tr.Mui-selected:not(.altCheck) {
        background-color: #fff !important;
      }
      table tbody tr.Mui-selected.altCheck {
        background-color: #ffcdc7 !important;
      }
    }
  }
`;
